<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users"></i> Cadastro de Lista Inteligente</h3>
        <small>
            Cadastro de lista inteligente de contatos para envio via e-mail, WhatsApp, criar listas para campanhas e geração de cards.
        </small>
      </div>
    </div>
    <ListaInteligenteAdd v-if="showAdd" ref="ListaInteligenteAdd" v-on:Back="onBack" />
    <ListaInteligenteGrid
      v-else
      ref="ListaInteligenteGrid"
      v-on:New="onNew"
      v-on:Edit="onEdit"
    />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ListaInteligenteAdd from './components/add/ListaInteligenteAdd.vue'
import ListaInteligenteGrid from './components/list/ListaInteligenteGrid.vue'

export default {
  name: 'ListaInteligente',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ListaInteligenteAdd,
    ListaInteligenteGrid
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () { },
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ListaInteligenteAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/ListaInteligente.vue